"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = require("@material-ui/core/styles");

var _clsx = _interopRequireDefault(require("clsx"));

var _CatalogueCategoryListItem = _interopRequireDefault(require("../CatalogueCategoryListItem"));

// import { pickHTMLProps } from 'pick-react-known-prop';
var useStyles = (0, _styles.makeStyles)(function () {
  return (
    /* theme */
    {
      root: {
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'flex-start'
      }
    }
  );
}, {
  name: 'CategoryCarouselItem'
});

var CategoryCarouselItem = /*#__PURE__*/_react.default.forwardRef(function CategoryCarouselItema(_ref, ref) {
  var pClasses = _ref.classes,
      className = _ref.className,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["classes", "className"]);
  var classes = useStyles({
    classes: pClasses
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    ref: ref,
    className: (0, _clsx.default)(classes.root, className)
  }, /*#__PURE__*/_react.default.createElement(_CatalogueCategoryListItem.default, rest));
});

process.env.NODE_ENV !== "production" ? CategoryCarouselItem.propTypes = {
  classes: _propTypes.default.shape({
    addToCart: _propTypes.default.string,
    availability: _propTypes.default.string,
    image: _propTypes.default.string,
    productPrice: _propTypes.default.string,
    root: _propTypes.default.string,
    title: _propTypes.default.string
  }),
  className: _propTypes.default.string
} : void 0;
CategoryCarouselItem.defaultProps = {
  classes: undefined,
  className: undefined
};
var _default = CategoryCarouselItem;
exports.default = _default;